/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});



	//  home page hover animation
	let spirit = $('.spirit-hero-con'),
		spirita = $('.spirit-hero-con a'),
		spiritText = $('.spirit-wear-hero-txt'),
		uniforms = $('.uniform-hero-con'),
		uniformsa = $('.uniform-hero-con a'),
		uniformText = $('.uniforms-hero-txt');
	spirit.mouseover(function() { uniformText.addClass('spirit-hover') });
	spirit.mouseout (function() { uniformText.removeClass('spirit-hover') });
	spirita.focus(function() { uniformText.addClass('spirit-hover') });
	spirita.blur (function() { uniformText.removeClass('spirit-hover') });
	uniforms.mouseover(function() { spiritText.addClass('uniform-hover') });
	uniforms.mouseout(function() { spiritText.removeClass('uniform-hover') });
	uniformsa.focus(function() { spiritText.addClass('uniform-hover') });
	uniformsa.blur(function() { spiritText.removeClass('uniform-hover') });

	// Contact Team Up HQ slide in form animation
	let contactBtn = $('.contact-hq-btn'),
		formCon = $('.contact-hq-form-slider'),
		closeForm = $('.close-contacthq-btn'),
		focusedElementBeforeSlider = contactBtn;
	formCon.attr('aria-hidden', 'true');
	$('.slide-out-form').siblings().hide();
	closeForm.hide();
	contactBtn.click(function(e) {
		e.preventDefault();
		slideOpenForm();
	});
	closeForm.click(function(e) {
		e.preventDefault();
		slideCloseForm();
	});
	if ($('.gform_wrapper').hasClass('gform_validation_error')) {
		slideOpenForm();
	}

	function slideOpenForm(e) {
		// Trap tab key in form
		if (document.activeElement == document.querySelector('body')){
			focusedElementBeforeSlider = contactBtn;
		} else {
			focusedElementBeforeSlider = document.activeElement;
		}
		$('.slide-out-form').siblings().show();
		closeForm.show();
		formCon.on('keydown', trapTabKey);
		let focusableElements = formCon.find('a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]');
		focusableElements = Array.prototype.slice.call(focusableElements);
		let firstTabStop = focusableElements[0];
  		let lastTabStop = focusableElements[focusableElements.length - 1];
		formCon.attr('aria-hidden', 'false');
		setTimeout(function(){
			formCon.css('left', '0');
		}, 100);
		firstTabStop.focus();
		function trapTabKey(e) {
			// Check for TAB key press
			if (e.keyCode === 9) {
			  // SHIFT + TAB
			  if (e.shiftKey) {
				if (document.activeElement === firstTabStop) {
				  e.preventDefault();
				  lastTabStop.focus();
				}
		
			  // TAB
			  } else {
				if (document.activeElement === lastTabStop) {
				  e.preventDefault();
				  firstTabStop.focus();
				}
			  }
			}
		
			// ESCAPE
			if (e.keyCode === 27) {
				slideCloseForm();
			}
		}
	}
	function slideCloseForm(e) {
		formCon.css('left', '-100%');
		setTimeout(function(){
			formCon.attr('aria-hidden', 'true');
			$('.slide-out-form').siblings().hide();
			closeForm.hide();
		}, 1000);
		focusedElementBeforeSlider.focus();
	}

	// flip cards tabbing
	$('.flip-card').attr('tabIndex', '0');

		//show more button
	$( "button.filterSport" ).click(function(event) {
		event.preventDefault();
		$( ".filter-sport" ).slideToggle( "slow" );
			var $this = jQuery(this);
			  $this.toggleClass("open");
	  
			  if ($this.hasClass("open")) {
				  $this.css("margin-bottom", "0");
			  } else {
				$this.css("margin-bottom", "20px");
			  }
	  });
	
		  $('.wp-block-gallery .wp-block-image').each(function() {
			var $figure = $(this);
			var $link = $figure.find('a');
			var $caption = $figure.find('.wp-element-caption');
		
			if ($link.length && $caption.length) {
			  $link.append($caption);  
			}
		  });
}); 

document.addEventListener('DOMContentLoaded', function () {
	const galleryContainer = document.querySelector('.wp-block-gallery');
  
	if (!galleryContainer) {
	  return;
	}
  
	const filterCheckboxes = document.querySelectorAll('.filter-controls input[type="checkbox"]');
	const images = document.querySelectorAll('.wp-block-gallery .wp-block-image');
  
	function filterImages() {
	  const activeFilters = Array.from(filterCheckboxes)
		.filter(checkbox => checkbox.checked)
		.map(checkbox => checkbox.getAttribute('data-filter'));
  
	  if (activeFilters.length === 0) {
		// Show all images if no filters are selected
		images.forEach(image => {
		  image.style.display = 'block';
		});
	  } else {
		// Filter images based on selected filters
		images.forEach(image => {
		  const imageFilters = Array.from(image.classList);
		  if (activeFilters.some(filter => imageFilters.includes(filter))) {
			image.style.display = 'block';
		  } else {
			image.style.display = 'none';
		  }
		});
	  }
  
	  // After filtering, initialize Masonry layout
	  if (typeof Masonry === 'function') {
		var msnry = new Masonry(galleryContainer, {
		  itemSelector: '.wp-block-image',
		  columnWidth: '.wp-block-image',
		  percentPosition: true,
		  gutter: 20
		});
	  }
	}
  
	// Add event listeners to checkboxes
	filterCheckboxes.forEach(checkbox => {
	  checkbox.addEventListener('change', filterImages);
	});
  
	// Initial filter application on page load
	filterImages();  
	setTimeout(filterImages, 1000);
  });
  
